import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ContentBlock } from '../../models';
import { CookiePreferences } from '@teamfoster/sdk/cookie-ngrx';
import { DefaultItem } from '../../models/defaultItem.model';
import { YoutubePlayerVars } from '@teamfoster/sdk/youtube-player';
import { ContentBlockBaseComponent } from '../content-block-base/content-block-base.component';

@Component({
  selector: 'app-content-block-maas-default',
  templateUrl: './content-block-maas-default.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentBlockMaasDefaultComponent extends ContentBlockBaseComponent {
  @Input() hasDarkTheme?: boolean;
  @Input() activeScrollTrigger: string[] = [];

  trackByFn(index: number, item: DefaultItem) {
    return item.id;
  }

  hasMedia(item: DefaultItem) {
    return item?.image?.url || item?.videoUrl;
  }

  id(item: DefaultItem) {
    return 'maas-block-' + item.id;
  }
}
